
import React, { useCallback, useEffect, useState } from 'react'
import * as styled from '../../style/main.style'
import { useTranslation } from 'react-i18next'
import { Button, MenuItem, Typography, ListItemText, Box } from '@mui/material'
import { ButtonContained, ButtonOutlined } from '../../../../component/mui-custom/MuiCustom'
import { RouteImage } from '../../../../assets/routeImage'
import { colors } from '../../../../constants/colors'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import CloseIcon from '@mui/icons-material/Close';

// COMPONENT
import Header from '../../Header'
import Navbar from '../../Navbar'
import HeaderTopicTable from '../../../../component/header-table/HeaderTopicTable'
import FilterSelect from '../../../../component/select/filterSelect'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import TableCustom from '../../../../component/table/tableCustom'
// STORE
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../store/slice/loading/loading.slice'

// API
import { RolesApi, rolesType, rolesTypeProps } from '../../../../api/roles/roles.api';
import Loading from '../../../../component/loading/Loading'
import { swalSuccess } from '../../../../component/notification/swal'
import { disableStyleButtonMui } from '../../../../utils/disableStyleButton'
import { notificationSwal } from '../../../../utils/notification.swal'

const ManageRole: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate: NavigateFunction = useNavigate();
    const isLoading = useSelector((state: any) => state.loading.isLoading)

    const [rolesData, setRolesData] = useState<any>(null);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [keyword, setKeyword] = useState<string>("");
    const [showModalAddModal, setShowAddModal] = useState<boolean>(false);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [roleId, setRoleId] = useState<number>(Number);
    const [roleDetail, setRoleDetail] = useState<rolesTypeProps>({
        roleName: "",
        roleStatus: "",
        permission: []
    });
    const [addRoles, setAddRoles] = useState<rolesTypeProps>({
        roleStatus: t("STATUS.ACTIVE"),
        roleName: "",
        permission: []
    })

    const handleChangeStatus = (event: React.ChangeEvent<HTMLSelectElement>) => setAddRoles({ ...addRoles, roleStatus: event.target.value })
    const handleToggleModal = () => setShowAddModal(!showModalAddModal)
    const handleToggleModalEdit = () => setShowEditModal(!showEditModal)
    const handleEdit = async (id: number) => {
        dispatch(setLoading())
        handleToggleModalEdit()
        setRoleId(id)
        await RolesApi.getDetail(id)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    const { roleName, status } = res.data?.result
                    setRoleDetail((prev) => ({ ...prev, roleName: roleName, roleStatus: status }))
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleChangeRoles = async (roleId: number, roleName: string, status: string) => {
        dispatch(setLoading())
        let condition: rolesTypeProps = {
            roleName: roleName,
            roleStatus: status,
            permission: []
        }
        await RolesApi.changeRoles(roleId, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    handleGetRoles()
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleAddRoles = async (event: React.FormEvent) => {
        event.preventDefault();
        dispatch(setLoading())
        await RolesApi.createRoles(addRoles)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => {
                handleToggleModal()
                handleGetRoles()
            })
    }
    const handleEditRoles = async (event: React.FormEvent) => {
        dispatch(setLoading())
        event.preventDefault();
        await RolesApi.changeRoles(roleId, roleDetail)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                    swalSuccess(notificationSwal.success)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalSuccess(notificationSwal.error)
                console.log(error)
            })
            .finally(() => {
                handleToggleModalEdit()
                handleGetRoles()
            })
    }

    const headCells = [
        {
            id: "ROLE", disablePadding: false, align: 'left', label:
                <HeaderTopicTable align='start' minWidth='906px' text='บทบาท' />
        },
        {
            id: "STATUS", disablePadding: true, align: 'center', label:
                <HeaderTopicTable align='center' text='สถานะ' />
        },
        {
            id: "EDIT", disablePadding: false, align: "left", label: ""
        }
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idRole, roleName, status } =
            objData;

        const objRenderData = {
            key: idRole,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "left", label: roleName,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component:
                        <div className='max-w-[153px]'>
                            <FilterSelect
                                headingNormal
                                renderValue={() =>
                                    <ListItemText className='relative'>
                                        {status === t("STATUS.ACTIVE") ? (
                                            <Typography
                                                className='text-light_success after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                                {t("STATUS.ACTIVE")}
                                            </Typography>
                                        ) : (
                                            <Typography
                                                className='text-danger after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                                {t("STATUS.INACTIVE")}
                                            </Typography>
                                        )}
                                    </ListItemText>
                                }

                                label={t('STATUS.LABEL')}
                                selectId="select-fiscal-year"
                                value={status}
                                labelId="label-fiscal-year"
                                onchange={(e) => handleChangeRoles(idRole, roleName, e.target.value)}
                                options={[
                                    <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                        <li>{t("STATUS.ACTIVE")}</li>
                                    </MenuItem>,
                                    <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                        <li>{t("STATUS.INACTIVE")}</li>
                                    </MenuItem>
                                ]}
                            />
                        </div>,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    },
                    width: 10,
                    component:
                        <div className='flex gap-2'>
                            <Button
                                onClick={() => handleEdit(idRole)}
                                startIcon={<img src={RouteImage.editPen} />}
                                sx={disableStyleButtonMui}>{"แก้ไข"}
                            </Button>
                            <Button onClick={() => navigate(`/auth/setting/permission/detail/${idRole}`)} className='cursor-pointer w-[24px]'>
                                <img src={RouteImage.detailIcon} width={24} alt="icons" />
                            </Button>
                        </div>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };
    const handleGetRoles = useCallback(async () => {
        dispatch(setLoading())
        let condition: rolesType = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, limit: pageLimit }
        if (keyword) condition = { ...condition, keyword: keyword }
        await RolesApi.getRoles(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data)
                    setRolesData(res.data?.result?.items)
                    setTotalItems(res.data?.result?.meta?.totalItems)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }, [page, pageLimit, keyword])

    useEffect(() => {
        handleGetRoles();
    }, [page, pageLimit, keyword])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            {/* {showModalAddModal && (
                <ModalCustom
                    buttonType='submit'
                    maxHeight={'auto'}
                    alignHeader='center'
                    heading='เพิ่มบทบาท'
                    component=
                    {
                        <form onSubmit={handleAddRoles} className='w-full'>
                            <Box className='w-full mt-8 flex flex-col gap-5'>
                                <CloseIcon
                                    onClick={handleToggleModal}
                                    className='text-danger cursor-pointer absolute top-0 right-0 mt-5 mr-5'
                                />
                                <span className='grid grid-cols-6 gap-[10px]'>
                                    <div className='col-span-6 md:col-span-6'>
                                        <InputTextField
                                            required
                                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setAddRoles({ ...addRoles, roleName: e.target.value })}
                                            value={addRoles.roleName}
                                            heading='ตำแหน่ง'
                                        />
                                    </div>
                                </span>
                                <span>
                                    <FilterSelect
                                        required
                                        heading='สถานะ'
                                        headingNormal
                                        label={t('STATUS.LABEL')}
                                        selectId="select-fiscal-year"
                                        value={addRoles.status}
                                        labelId="label-fiscal-year"
                                        onchange={handleChangeStatus}
                                        options={[
                                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                                <li className='text-primary'>{t("STATUS.ACTIVE")}</li>
                                            </MenuItem>,
                                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                                <li className='text-danger'>{t("STATUS.INACTIVE")}</li>
                                            </MenuItem>
                                        ]}
                                    />
                                </span>
                                <span className='mt-3 flex items-center justify-center'>
                                    <ButtonContained
                                        type='submit'
                                        sx={{ maxWidth: 90 }}
                                    >
                                        {t("BUTTON.SAVE")}
                                    </ButtonContained>
                                </span>
                            </Box>
                        </form>
                    }
                />
            )}
            {showEditModal && (
                <ModalCustom
                    maxHeight='auto'
                    heading='แก้ไขสิทธิ์'
                    enableExit={handleToggleModalEdit}
                    component={
                        <form onSubmit={handleEditRoles} className='w-full'>
                            <Box className='w-full mt-8 flex flex-col gap-5'>
                                <CloseIcon
                                    onClick={handleToggleModalEdit}
                                    className='text-danger cursor-pointer absolute top-0 right-0 mt-5 mr-5'
                                />
                                <span className='grid grid-cols-6 gap-[10px]'>
                                    <div className='col-span-6 md:col-span-6'>
                                        <InputTextField
                                            required
                                            onchange={(e: React.ChangeEvent<HTMLInputElement>) => setRoleDetail((prev) => ({ ...prev, roleName: e.target.value }))}
                                            value={roleDetail && roleDetail?.roleName}
                                            heading='ตำแหน่ง'
                                        />
                                    </div>
                                </span>
                                <span>
                                    <FilterSelect
                                        required
                                        heading='สถานะ'
                                        headingNormal
                                        label={t('STATUS.LABEL')}
                                        selectId="select-fiscal-year"
                                        value={roleDetail && roleDetail?.status}
                                        labelId="label-fiscal-year"
                                        onchange={(e: React.ChangeEvent<HTMLSelectElement>) => setRoleDetail((prev) => ({ ...prev, status: e.target.value }))}
                                        options={[
                                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                                <li className='text-primary'>{t("STATUS.ACTIVE")}</li>
                                            </MenuItem>,
                                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                                <li className='text-danger'>{t("STATUS.INACTIVE")}</li>
                                            </MenuItem>
                                        ]}
                                    />
                                </span>
                                <span className='mt-3 flex items-center justify-center'>
                                    <ButtonContained
                                        type='submit'
                                        sx={{ maxWidth: 90 }}>
                                        {t("BUTTON.SAVE")}
                                    </ButtonContained>
                                </span>
                            </Box>
                        </form>}
                />
            )} */}
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <styled.TopicHeader>
                        <div>
                            <Typography className='text-primary' variant='h4'>
                                จัดการบทบาท
                            </Typography>
                        </div>
                        <span>
                            <ButtonOutlined
                                onClick={handleToggleModal}
                                startIcon={<img src={RouteImage.addButton} />}>
                                <Typography className='text-primary'> {t("BUTTON.ADD")}</Typography>
                            </ButtonOutlined>
                        </span>
                    </styled.TopicHeader>
                    <section className='mt-8 w-full h-auto'>
                        {rolesData && (
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={rolesData.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}

                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default ManageRole